import { ref, computed } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-03e6986e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "list_wrap"
};
const _hoisted_2 = {
  class: "top_title"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "left_title"
}, "设备ID", -1));
const _hoisted_4 = {
  class: "list_container"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["title"];
const _hoisted_7 = {
  class: "text"
};
import { CopyOutlined } from '@ant-design/icons-vue';
import { copy } from '@/common';
import { deleteTestDeviceFetch } from '@/api/sandbox';
import { Empty, message } from 'ant-design-vue';
import SvgIcon from '@/components/SvgIcon.vue';
import { reportEvent } from '@/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceList',
  props: {
    loading: {
      type: Boolean,
      defualt: false
    },
    deviceList: {
      type: Array,
      defualt: () => []
    },
    dbtId: {
      type: String
    },
    curDeviceId: {
      type: String
    }
  },
  emits: ['add', 'updateList', 'change'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const deviceId = ref('');
    const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
    const deviceListByFilter = computed(() => {
      var _props$deviceList$fil, _props$deviceList;
      if (!deviceId.value) {
        return props.deviceList;
      }
      const keyword = deviceId.value.toLowerCase(); // 转换为小写以进行不区分大小写的比较
      return (_props$deviceList$fil = (_props$deviceList = props.deviceList) === null || _props$deviceList === void 0 ? void 0 : _props$deviceList.filter(item => String(item).toLowerCase().includes(keyword))) !== null && _props$deviceList$fil !== void 0 ? _props$deviceList$fil : [];
    });
    const changeDeviceId = item => {
      emit('change', item);
    };
    const deleteId = async id => {
      try {
        const {
          code
        } = await deleteTestDeviceFetch({
          deviceId: id,
          dbtId: props.dbtId
        });
        if (code === '0000') {
          message.success('删除成功');
          emit('updateList');
          reportEvent({
            eventName: 'element_use',
            properties: {
              ui_name: '测试配置',
              element_name: '删除设备ID'
            }
          });
        }
      } catch (error) {}
    };
    const add = () => {
      emit('add');
    };
    return (_ctx, _cache) => {
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_input_search = _resolveComponent("a-input-search");
      const _component_a_popconfirm = _resolveComponent("a-popconfirm");
      const _component_a_spin = _resolveComponent("a-spin");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_a_tooltip, {
        title: "添加设备ID"
      }, {
        default: _withCtx(() => [_createElementVNode("a", {
          onClick: add
        }, [_createVNode(SvgIcon, {
          "icon-class": "add_no_color",
          "class-name": "add-icon"
        })])]),
        _: 1
      })]), _createElementVNode("div", null, [_createVNode(_component_a_input_search, {
        value: deviceId.value,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => deviceId.value = $event),
        valueModifiers: {
          trim: true
        },
        placeholder: "设备ID查询",
        style: {
          "width": "100%"
        }
      }, null, 8, ["value"])]), _createVNode(_component_a_spin, {
        spinning: __props.loading
      }, {
        default: _withCtx(() => {
          var _unref2;
          return [_createElementVNode("div", _hoisted_4, [(_unref2 = _unref(deviceListByFilter)) !== null && _unref2 !== void 0 && _unref2.length ? (_openBlock(true), _createElementBlock(_Fragment, {
            key: 0
          }, _renderList(_unref(deviceListByFilter), item => {
            return _openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["list_container_inner", {
                active: __props.curDeviceId === item
              }]),
              key: item,
              onClick: $event => changeDeviceId(item)
            }, [_createElementVNode("div", {
              class: "list_item",
              title: item
            }, [_createElementVNode("div", _hoisted_7, _toDisplayString(item), 1), _createVNode(_unref(CopyOutlined), {
              class: "copy_icon",
              onClick: _withModifiers($event => _unref(copy)(item), ["stop"])
            }, null, 8, ["onClick"])], 8, _hoisted_6), _createElementVNode("div", {
              class: "delete",
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
            }, [_createVNode(_component_a_popconfirm, {
              title: "确定删除设备ID吗?",
              onConfirm: $event => deleteId(item)
            }, {
              default: _withCtx(() => [_createVNode(SvgIcon, {
                iconClass: "delete",
                className: "delete_icon"
              })]),
              _: 2
            }, 1032, ["onConfirm"])])], 10, _hoisted_5);
          }), 128)) : (_openBlock(), _createBlock(_unref(Empty), {
            key: 1,
            image: _unref(simpleImage)
          }, null, 8, ["image"]))])];
        }),
        _: 1
      }, 8, ["spinning"])]);
    };
  }
});